import { render, staticRenderFns } from "./firstpurchase.vue?vue&type=template&id=224600fd&scoped=true"
import script from "./firstpurchase.vue?vue&type=script&lang=ts"
export * from "./firstpurchase.vue?vue&type=script&lang=ts"
import style0 from "./firstpurchase.vue?vue&type=style&index=0&id=224600fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224600fd",
  null
  
)

export default component.exports